import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/svg/close-pos.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3e4a4789"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "view-wrapper"
};
var _hoisted_2 = {
  class: "dialog_content"
};
var _hoisted_3 = {
  class: "d-flex fl-col fl-s-b f-center",
  style: {
    "align-items": "center"
  }
};
var _hoisted_4 = {
  class: "d-flex fl-col fl-j-c m-80 f-center"
};
var _hoisted_5 = {
  style: {
    "font-size": "35px",
    "text-align": "center"
  }
};
var _hoisted_6 = {
  class: "mt-10",
  style: {
    "font-size": "30px"
  }
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "sales closed",
    class: "closed-image"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("salesclosedbanner.sales-closed")), 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("salesclosedbanner.something-available")), 1)]), _hoisted_7, _createVNode(_component_el_button, {
    class: "primary booking-button f-bold m-80",
    type: "primary",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.startSales();
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("salesclosedbanner.open-sales")), 1)];
    }),
    _: 1
  })])])]);
}